import { useEffect, useState, useRef } from 'react';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { API_SYNCRONOUSCLASS_VIEW } from '../../../Domain/Redux/Paths';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';

export const useTelepresencePurchaseCard = ({ schedulerInfo, language }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCombo, setShowCombo] = useState(false);
  const [calendarList, setCalendarList] = useState({});

  // Ref para almacenar los IDs que ya hicieron la petición
  const fetchedIds = useRef(new Set());

  useEffect(() => {
    if (!language || !schedulerInfo?.id) return;

    // Verificar si el ID ya está en la lista
    if (fetchedIds.current.has(schedulerInfo.id)) return;

    // Marcar el ID como procesado
    fetchedIds.current.add(schedulerInfo.id);

    HttpClient.GET(API_SYNCRONOUSCLASS_VIEW, {
      scheduler: schedulerInfo.id,
      all: true,
      multilanguage_id: language,
      component: COMPONENTS.COUNTRY
    })
      .then((response) => {
        if (response?.results && response.results.length > 0) {
          setCalendarList({
            list: response.results,
            timeZone: response.time_zone?.join(', '),
            frecuency: response.scheduler_frecuency
          });
        }
      })
      .catch((error) => {
        // En caso de error, eliminar el ID para permitir reintentos
        fetchedIds.current.delete(schedulerInfo.id);
        console.error('Error fetching calendar list:', error);
      });
  }, [language, schedulerInfo]);

  return {
    showCalendar,
    setShowCalendar,
    showCombo,
    setShowCombo,
    calendarList
  };
};
